module.exports = __webpack_public_path__ + "static/media/m1.415f23e7.png";